<template>
  <upPopup
    :show="show"
    @close="close"
    :title="tag"
    :showCloseBtn="true"
    :autoHeight="false"
    :buttons="buttons"
    :label="'我知道了'"
    class="qingsu-tag-model-box"
  >
    <div class="qingsu-tag-model">
      <div>
        <dl class="list">
          <dd :class="{ desc: true, 'desc-pb': index === 5 }">
            {{ tagDetail }}
          </dd>
        </dl>
      </div>
    </div>
  </upPopup>
</template>

<script>
import upPopup from '../common/upPopup.vue'

export default {
  components: {
    upPopup
  },
  props: {
    tag: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      default() {
        return [{ label: '我知道了' }]
      }
    }
  },
  computed: {
    tagMaps() {
      return {
        热门TOP30: '近一个月倾听时长为入驻倾听师前30名',
        近期入驻TOP50: '新入驻的倾听师，近一个月内倾听时长前50名',
        好评TOP50: '入驻倾听师中，有内容的好评数量前50名',
        人气飙升TOP50: '入驻倾听师中，近一个月内倾听时长增长速度为前50名',
        已入驻: '倾听师入驻壹心理平台已3年及以上',
        咨询师资质:
          '倾听师拥有咨询师资质证书，包括人社部二、三级咨询师资格证，中国心理学会注册系统的注册督导师、心理师和助理心理师，卫生部初级、中级治疗师，精神科执业医师执照',
        快速响应: '倾听师近一个月倾诉订单98%达到平台快速响应标准',
        '12.12嘉年华':
          '此倾听师参与12.12嘉年华活动，可在主页选择TA的倾诉套餐，折扣12月23日即止。'
      }
    },
    tagDetail() {
      if (!this.tag) {
        return ''
      }
      if (this.tag.includes('已入驻')) {
        return this.tagMaps['已入驻']
      }
      return this.tagMaps[this.tag] || ''
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.qingsu-tag-model-box {
  /deep/ .common-model-up-btn {
    height: 86px;
    background: linear-gradient(180deg, #fecec6 0%, #fc7052 100%);
    border-radius: 48px;
    /deep/ .common-model-up-btn-label {
      font-size: 32px;
      font-weight: 600;
    }
  }
  /deep/ .common-model-up-close-btn {
    display: none;
  }
}
.qingsu-tag-model {
  padding: 20px 30px 43px;
  max-height: 800px;
  .list {
    padding-bottom: 20px;
    .desc {
      font-size: 26px;
      color: #6c798c;
      line-height: 38px;
      margin-bottom: 50px;
    }
    .desc-pb {
      margin-bottom: 0;
    }
  }
  .close-btn {
    font-size: 26px;
    color: #ffffff;
    line-height: 28px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 80px;
    background: #ffa202;
  }
}
</style>
